import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Heading, Stat } from "./NKDaily";
import LoadedQuestions from "./LoadedQuestions";

export default function NKDuelAdmin() {
  const [state, setState] = useState(null);
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    const tick = async () => {
      try {
        const r = await api.get("/admin/modes/status");
        setState(r.data.duel);
        // Recent resolved matches via admin stats (no dedicated endpoint yet)
        // For now we'll just show the counts; richer feed is a follow-up.
      } catch { /* */ }
    };
    tick(); const id = setInterval(tick, 8000); return () => clearInterval(id);
  }, []);

  return (
    <div className="space-y-6">
      <Heading title="NK Duel" subtitle="Async head-to-head. Gate Q → matchmaking → 5 questions." />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Stat label="In queue (WAITING)" value={state?.queued ?? "—"} />
        <Stat label="Active matches" value={state?.active ?? "—"} />
        <Stat label="Resolved today" value="—" />
      </div>
      <div className="nk-card p-4">
        <p className="eyebrow mb-2">Disputes & moderation</p>
        <p className="text-sm text-nk-mute">Players can report suspicious duels from the match detail screen.
        Reports surface in the <b className="text-nk-text">Reports</b> page; resolve there.</p>
      </div>
      <LoadedQuestions mode="duel" />
    </div>
  );
}
